import * as types from '../mutation-types'

const moduleEmpresa = {
	state: {
        empresa: {},
	},
	getters: {
        empresa: state => { return state.empresa },
	},
	mutations: {
        [types.ADD_EMPRESA](state, empresa) { state.empresa = empresa },
	},
	actions: {
		addEmpresa({ commit }, empresa) {
			commit(types.ADD_EMPRESA, empresa)
		},
	},
}
export default moduleEmpresa